const getArrayFirst = <T = unknown>(array?: T[]): T | null => {
  if (!array || array.length === 0) return null
  return array[0]
}

export default getArrayFirst
